<template>
    <div v-if="mode !== 'button'" class="copy-text">
        <div ref="text" class="mr-1 align-middle inline">
            <slot></slot>
        </div>
        <button @click="copyText" class="align-middle p-0 m-0 invisible leading-none">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"/>
                <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"/>
            </svg>
        </button>
    </div>
    <button v-else @click="copyText">
        <slot>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"/>
                <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"/>
            </svg>
        </slot>
    </button>
</template>

<script>
import {computed, defineComponent} from 'vue';

export default defineComponent({
    name: 'CopyText',
    props: {
        text: String,
        mode: String,
    },
    setup(props, { slots }) {
        const canCopy = computed(() => {
            return typeof navigator.clipboard !== 'undefined';
        });

        return {
            canCopy,
            copyText() {
                const text = props.text ?? slots.default()[0].text;

                if (canCopy.value) {
                    navigator.clipboard.writeText(text)
                        .then(() => {
                        })
                        .catch(err => {
                            console.error('Could not copy text: ', err);
                        });
                } else {
                    prompt('Clipboard is API not available, copy the text below', text);
                }
            },
        };
    },
});
</script>

<style lang="scss" scoped>
.copy-text {
    &:hover button {
        visibility: visible
    }
}
</style>
